// extracted by mini-css-extract-plugin
module.exports = {"button":"Search_button__3vkvL","group":"Search_group__1ZHCG"};